export default __webpack_public_path__ + "static/media/ChronicleSSm-Light_Web.7d76bf54.woff";